module.exports = __webpack_public_path__ + "img/kuangjiao_xc3.2281205d.jpg";